import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import {
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Slide,
} from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { RichiestaPreventivoCreateDto, RichiestaPreventivoTipo } from "@/api";

const { lubrifica: LUBRIFICA, lavorazioniMeccaniche: LAVORAZIONI_MECCANICHE } =
  RichiestaPreventivoTipo;

interface Step1TipoRichiestaProps {
  activeStep: number;
  slideDirection: "left" | "right";
  control: Control<RichiestaPreventivoCreateDto>;
}

export function Step1_TipoRichiesta({
  activeStep,
  slideDirection,
  control,
}: Step1TipoRichiestaProps) {
  const { t } = useTranslation();

  return (
    <Slide
      direction={slideDirection}
      in={activeStep === 1}
      timeout={500}
      unmountOnExit
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          bgcolor: "white",
          position: activeStep === 1 ? "relative" : "absolute",
          width: "100%",
          top: 0,
        }}
      >
        <Box>
          <Typography variant="h5" gutterBottom mb={3} sx={{ color: "#333" }}>
            {t("richiestaPreventivo.step2.title")}
          </Typography>

          <FormControl component="fieldset" fullWidth>
            <Controller
              name="tipo"
              control={control}
              rules={{ required: t("richiestaPreventivo.step2.required") }}
              render={({ field }) => (
                <RadioGroup {...field}>
                  <Card
                    sx={{
                      mb: 2,
                      cursor: "pointer",
                      border: 2,
                      borderColor:
                        field.value === LUBRIFICA ? "#667eea" : "#e0e0e0",
                      bgcolor: "white",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        borderColor: "#667eea",
                        boxShadow: 2,
                      },
                    }}
                    onClick={() => field.onChange(LUBRIFICA)}
                  >
                    <CardContent>
                      <FormControlLabel
                        value={LUBRIFICA}
                        control={<Radio />}
                        label={
                          <Box>
                            <Typography variant="h6" sx={{ color: "#333" }}>
                              {t("richiestaPreventivo.step2.lubrifica.label")}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#665" }}>
                              {t(
                                "richiestaPreventivo.step2.lubrifica.description",
                              )}
                            </Typography>
                          </Box>
                        }
                      />
                    </CardContent>
                  </Card>

                  <Card
                    sx={{
                      cursor: "pointer",
                      border: 2,
                      borderColor:
                        field.value === LAVORAZIONI_MECCANICHE
                          ? "#667eea"
                          : "#e0e0e0",
                      bgcolor: "white",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        borderColor: "#667eea",
                        boxShadow: 2,
                      },
                    }}
                    onClick={() => field.onChange(LAVORAZIONI_MECCANICHE)}
                  >
                    <CardContent>
                      <FormControlLabel
                        value={LAVORAZIONI_MECCANICHE}
                        control={<Radio />}
                        label={
                          <Box>
                            <Typography variant="h6" sx={{ color: "#333" }}>
                              {t("richiestaPreventivo.step2.lavorazioni.label")}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#666" }}>
                              {t(
                                "richiestaPreventivo.step2.lavorazioni.description",
                              )}
                            </Typography>
                          </Box>
                        }
                      />
                    </CardContent>
                  </Card>
                </RadioGroup>
              )}
            />
          </FormControl>
        </Box>
      </Paper>
    </Slide>
  );
}
